module.exports = __webpack_public_path__ + "dist/img/nissan-logo-old.fc710952.png";